import { render, staticRenderFns } from "./balanceBySalesGroup.vue?vue&type=template&id=9bf69744&scoped=true"
import script from "./balanceBySalesGroup.vue?vue&type=script&lang=js"
export * from "./balanceBySalesGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf69744",
  null
  
)

export default component.exports